import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function SpaCardSkeleton() {
  return (
    <div className="rounded-2xl bg-white border border-[rgba(17,24,39,0.06)] overflow-hidden">
      <Skeleton className="w-full h-48" />
      <div className="p-4 space-y-3">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}

export function SpaGridSkeleton({ count = 6 }) {
  // Static placeholders that never reorder — use stable string keys instead
  // of array indices to satisfy lint rules and avoid spurious re-mounts.
  const slots = Array.from({ length: count }, (_, i) => `sk-${i}`);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {slots.map((id) => <SpaCardSkeleton key={id} />)}
    </div>
  );
}
